import React, { useState } from 'react'
import Box from '@mui/material/Box';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Grid from '@mui/material/Grid';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';
import { Close } from '@mui/icons-material';
import { ActionButtons } from '../others/ActionButtons';
import { RenderFilts } from './RenderFilts';
import { ActionIconItem } from '../others/ActionIconItem';
export const Filter = ({ data, handleFilter, appliedFilters = {} }) => {
    const [filters, setFilter] = useState({});
    const [open, setopen] = useState(false);
    const [session, setSession] = useState(0);
    const search = () => {
        handleFilter(filters);
        setopen(false);
    }

    const clearAll = () => {
        setFilter({});
        handleFilter({});
        setopen(false);
    }

    const openDialog = () => {
        const next = {};
        (data?.filter || []).forEach((field) => {
            if (appliedFilters?.[field.id]) next[field.id] = appliedFilters[field.id];
        });
        setFilter(next);
        setSession((current) => current + 1);
        setopen(true);
    }

    const setfilter = (param, param2) => {
        setFilter(prev => ({
            ...prev, [param2]: param
        }));
    }

    const deletefilter = (param) => {
        setFilter(prev => {
            if (!Object.prototype.hasOwnProperty.call(prev, param)) return prev;
            const next = { ...prev };
            delete next[param];
            return next;
        });
    }

    return (
        <>
            <Tooltip title={data.accion}>
                <ActionIconItem
                    item={data}
                    onClick={() => openDialog()}
                />
            </Tooltip >
            <Dialog
                open={open}
                fullWidth
                maxWidth='sm'
            >
                <DialogTitle>
                    <Typography variant='h5' component='h5'>
                        Filtros
                    </Typography>
                    <IconButton
                        aria-label='close'
                        onClick={() => setopen(false)}
                        sx={{
                            position: 'absolute',
                            right: 8,
                            top: 8,
                            color: (theme) => theme.palette.grey[500],
                        }}
                    >
                        <Close />
                    </IconButton>
                </DialogTitle>
                <DialogContent>
                    <Box sx={{ mt: 2 }}>
                        <Box sx={{ mb: 2 }}>
                            <Typography variant='body2'>
                                Registro(s) con valor(es) que:
                            </Typography>
                        </Box>
                        <Grid container spacing={2}>
                            {
                                data?.filter
                                    .slice()
                                    .sort((a, b) => (a.type === 'boolean') - (b.type === 'boolean'))
                                    .map((field) => (
                                        <RenderFilts
                                            key={`${field.id}-${session}`}
                                            field={field}
                                            initialValue={filters[field.id]}
                                            setFilters={setfilter}
                                            deletefilter={deletefilter}
                                        />
                                    ))
                            }
                        </Grid>
                    </Box>
                    <ActionButtons
                        onCancel={() => setopen(false)}
                        onSubmit={search}
                        onSubmitOptional={clearAll}
                        cancelLabel={"Cancelar"}
                        submitLabel={"Filtrar"}
                        labelOptional={"Limpiar"}
                    />
                </DialogContent>
            </Dialog>
        </>
    )
}